export default {
    home: "Home",
    projects: "Cursos",
    community: "Comunidade",
    customization: "Personalização",
    reports: "Relatórios",
    marketing: "Marketing",
    settings: "Ajustamentos",
    my_account: 'A minha conta',
    annual_sales: "Vendas anuais",
    sales: "Vendas",
    students: "Estudantes",
    teachers: "Professores",
    products: "Produtos",
    project: "Projectos",
    categories: "Categorias",
    published: "Publicado em",
    name: "Nome",
    lastname: 'Apelido',
    email: "Email",
    phone: "Telefone",
    title: "Título",
    coming_soon: "Em breve",
    mount: "Mês",
    year: "Ano",
    date: "Data",
    plan: 'Plano',
    pvp: "RRP",
    net: "Net",
    state: "Estado",
    delete: "Eliminar",
    profile: "Perfil",
    enrollments: "Inscrições",
    cancel: "Anular",
    save: "Salvar",
    remove: 'eliminar',
    email_address: 'Endereço postal',
    image_format: 'PNG, JPG, GIF até 3MB',
    close: 'Fechar',
    back: 'Voltar a',
    coming_soon_brainspro: 'Brevemente a Brainspro',
    and: 'y',
    product: "Produto",
    date_creation: 'Data de criação',
    type: 'tipo',

    //AppComponent
    my_profile: 'O meu perfil',
    adjust: 'Ajustamentos',
    out: 'Saída',
    search: 'Pesquisa',
    academy_preview: 'Academia de pré-visualização',
    my_academy: 'A minha Academia',
    new_project: 'Novo Curso',
    text_current_period: 'O seu período experimental para ',
    text_end_at: ' termina em ',
    plans: 'Planos de assinatura',
    billing: 'Facturação',

    //ThankYouPageComponent
    thankyou: 'Obrigado',
    go_to_academy: 'Ir para a academia',

    //NavigationDesktop - Mobile
    records: 'Aufzeichnungen',
    videos: 'Videos',

    //Aviso de cambios sin guardar (FE-032)
    unsaved_changes_title: 'Tem alterações por guardar',
    unsaved_changes_text: 'Se sair agora, as alterações que não guardou serão perdidas.',
    unsaved_changes_leave: 'Sair sem guardar',
    unsaved_changes_stay: 'Continuar a editar',

    // FE-043 · RouteTabsComponent
    tabs: 'Separadores',

    // Botón Aula (Moodle)
    classroom_ready_title: 'A sala de aula está pronta',
    classroom_ready_text: 'O navegador bloqueou o novo separador. Clique em «Abrir sala de aula» para entrar no curso.',
    classroom_open: 'Abrir sala de aula',
    classroom_timeout: 'O Moodle está a demorar demasiado a responder. Tente novamente dentro de alguns minutos.',
    classroom_error: 'Não foi possível abrir a sala de aula do curso.',

    // Menú de navegación
    users: 'Utilizadores',
    navigation_menu: 'Menu de navegação',
    open_menu: 'Abrir menu',
    close_menu: 'Fechar menu',
}
